import React from "react";
import { Form } from "react-bootstrap";
import { TApiParameter } from "../../../../../api/endpoints/Parameter";
import { TParamQuantileOption } from "../../../../../api/endpoints/SubsetOption";
import Footnote from "../../../Footnote";
import FormError from "../../../FormError";
import ParamsQuantileSelector from "../../../ParamsQuantileSelector";
import { FormikProductFormField, TFormErrorMessage } from "../../index";

interface Props extends FormikProductFormField {
  spec: TParamQuantileOption;
  options: { [shortname: string]: TApiParameter }
}
const ParametersQuantileField = (props: Props ) => {
  const { formik, spec, options } = props;

  return (
    <Form.Group controlId="paramQuantile">
      <Form.Label>Parameters</Form.Label>
      <ParamsQuantileSelector
        values={formik.values.param_quantile}
        spec={spec}
        params={options}
        onChange={values => formik.setFieldValue('param_quantile', values)}
      />

      <FormError
        message={formik.errors.param_quantile as TFormErrorMessage}
        when={formik.touched.param_quantile && Boolean(formik.errors.param_quantile)}
      />

      <Footnote text={spec.footnote} />
    </Form.Group>
  )
}

export default ParametersQuantileField;
